
import Vue from 'vue';
import ClickOutside from 'vue-click-outside';
export default Vue.extend({
  name: 'SplitButton',
  directives: {ClickOutside},
  data() {
    return {
      open: false,
    };
  },
  methods: {
    close() {
      this.open = false;
    },
  },
});
